import React, {Component} from "react";
import {Card, Row} from "reactstrap";
import Hr from "../../components/hr/hr";

import "./form-section.css";

class FormSection extends Component {

    render() {
        const {component} = this.props;
        const cardClassName = this.props.cardClassName;
        const containerClassName = this.props.rowClassName;
        const sectionNumber = this.props.sectionNumber;
        const sectionLabel = this.props.sectionLabel;
        const sectionInfo = this.props.sectionInfo;
        const headerComponent = this.props.headerComponent;

        const hasSectionHeader = sectionNumber || sectionLabel;

        return (
            <Row className={containerClassName ? containerClassName : "mx-0 my-1 p-0"}>
                <Card className={cardClassName ? cardClassName : "mx-0 px-0 py-1 shadow container-fluid"}>
                    {hasSectionHeader && buildHeader(sectionNumber, sectionLabel, sectionInfo, headerComponent)}
                    {hasSectionHeader && <Hr/>}
                    <Row className="px-3 py-0">
                        {component}
                    </Row>
                </Card>
            </Row>
        )
    }


}

const buildHeader = (sectionNumber, sectionLabel, sectionInfo, headerComponent) => {

    return <Row className="ml-0 p-1">
        {sectionNumber &&
        (<h5 className="my-auto border border-dark rounded-circle Form-Section-section-number" style={{paddingLeft: 5}}>
            {sectionNumber}</h5>)
        }
        <div className="ml-2 my-auto text-left">
            <h6 className="m-0 p-0">{sectionLabel}</h6>
            <p className="m-0 p-0 small Form-Section-muted-opacity">{sectionInfo}</p>
        </div>

        {headerComponent &&
        <div className="ml-auto my-auto">
            {headerComponent}
        </div>
        }
    </Row>;
};

export default FormSection



// WEBPACK FOOTER //
// ./src/components/components/form-section/form-section.js